"use client";

import { routes } from "@/data/routes";
import { GlobalConsumer, useGlobalGetters, useGlobalSetters } from "@/data/store";
import { cn } from "@/lib/components";
import { CheckIcon, UserIcon } from "lucide-react";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { Button } from "../base/button";
import { Header } from "../blocks/Header";
import { HeaderCartIcon } from "../blocks/HeaderCartIcon";

export function HeaderContainer() {
  const pathname = usePathname();
  const isHomePage = pathname === "/";
  const { isLoggedIn } = useGlobalGetters(["isLoggedIn"]);
  const { setIsCartPopupOpened } = useGlobalSetters();

  useEffect(() => {
    setIsCartPopupOpened(false);
  }, [pathname, setIsCartPopupOpened]);

  return (
    <>
      <Header
        isHomePage={isHomePage}
        iconLinks={[
          {
            href: isLoggedIn ? routes.profile.path : undefined,
            icon: (
              <GlobalConsumer>
                {({ setIsAuthModalOpened }) =>
                  isLoggedIn ? (
                    <>
                      <UserIcon />
                      <CheckIcon
                        className={cn(
                          "absolute -right-2 -bottom-2",
                          "size-4 rounded-full bg-green-500 p-0.5 text-white",
                        )}
                      />
                    </>
                  ) : (
                    <Button
                      variant="ghost"
                      size="wrapper"
                      onClick={() => setIsAuthModalOpened(true)}
                    >
                      <UserIcon />
                    </Button>
                  )
                }
              </GlobalConsumer>
            ),
          },
          {
            href: routes.cart.path,
            icon: (
              <GlobalConsumer
                getters={["cartItems", "isCartPopupOpened"]}
                mutations={["removeFromCart"]}
              >
                {({ cartItems, isCartPopupOpened, removeFromCart, setIsCartPopupOpened }) => (
                  <HeaderCartIcon
                    cartItems={cartItems}
                    isCartPopupOpened={isCartPopupOpened}
                    onCartPopupChange={setIsCartPopupOpened}
                    onDelete={(productId) => removeFromCart(productId)}
                  />
                )}
              </GlobalConsumer>
            ),
          },
        ]}
      />
    </>
  );
}
